import { Component, computed, inject, input, output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import {
  AnchorComponent,
  DateComponent,
  DateFormat,
  FocusableNoopAnchorDirective,
  IconButtonComponent,
  TypedContextDirective,
} from '@ftr/foundation'
import { AppPaths, RequestPaths } from '@ftr/routing-paths'
import { RequestTypeUrlValue } from '../../../types'
import { RequestCartGroupComponent } from '../cart-group'
import { FakeCart } from '../fake-cart'

@Component({
  selector: 'ftr-request-cart-side-panel',
  templateUrl: './request-cart-side-panel.component.html',
  styleUrl: './request-cart-side-panel.component.css',
  imports: [
    AnchorComponent,
    DateComponent,
    FocusableNoopAnchorDirective,
    IconButtonComponent,
    RequestCartGroupComponent,
    RouterLink,
    TypedContextDirective,
  ],
})
export class RequestCartSidePanelComponent {
  // TODO - Replace with store
  private readonly fakeCart = inject(FakeCart)

  readonly courtSystemId = input.required<Uuid>()
  readonly requestType = input.required<RequestTypeUrlValue>()

  readonly closePanel = output()

  protected readonly cartGroups = computed(() => this.fakeCart.groupedItems())
  protected readonly cartPath = computed(() => [
    '/',
    AppPaths.Request,
    this.requestType(),
    RequestPaths.CourtSystem,
    this.courtSystemId(),
    RequestPaths.Cart,
  ])
  protected readonly dateFormat = DateFormat
}
